import { CautionDangerIcon } from "app/components/Icons";
import clsx from "clsx";
import React, { useEffect, useState } from "react";

interface Props {
  onChange: (val: string) => void;
  onBlurCommit?: (val: string) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  value: string;
  placeholder: string;
  error: string;
  inputClassName: string;
}

const URLInput: React.FC<Props> = ({
  value,
  placeholder,
  onChange,
  onBlurCommit,
  onKeyDown,
  error,
  inputClassName,
}) => {
  const [urlError, setUrlError] = useState<string | null>(null);
  const [isFocused, setIsFocused] = useState(false);

  const isValidUrl = (val?: string) => {
    if (!val) return false;

    const trimmed = val.trim();
    if (!trimmed) return false;

    try {
      // Accept values with protocol
      new URL(trimmed);
      return true;
    } catch (e) {
      try {
        // Accept values without protocol by prepending https://
        new URL(`https://${trimmed}`);
        return true;
      } catch (err) {
        return false;
      }
    }
  };

  useEffect(() => {
    // validate when value prop changes (handles programmatic updates)
    if (!value || value.trim() === "") {
      setUrlError(null);
      return;
    }

    if (!isValidUrl(value)) {
      setUrlError("Please enter a valid URL");
    } else {
      setUrlError(null);
    }
  }, [value]);

  return (
    <div
      className={`flex items-center gap-[8px] h-[42px] flex-row   rounded px-2.5 ${
        error
          ? "border-danger bg-danger100 "
          : isFocused
            ? "border-secondary border"
            : " "
      }${inputClassName}`}
    >
      <input
        type="text"
        className={clsx(
          "text-sm rounded w-full text-black leading-[21px] focus:outline-none !placeholder-gray-300 placeholder-normal placeholder:text-sm placeholder:leading-[21px]",
          error ? "!bg-danger100 !text-danger " : "bg-transparent",
        )}
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          const val = e.target.value;
          onChange(val);
          if (urlError && isValidUrl(val)) setUrlError(null);
        }}
        onBlur={(e) => {
          const val = e.target.value.trim();
          if (val && !isValidUrl(val))
            setUrlError("Please enter a valid URL");
          else if (!error) setIsFocused(false);
          else setUrlError(null);
          onBlurCommit?.(e.target.value);
        }}
        onKeyDown={onKeyDown}
        onFocus={() => {
          setIsFocused(true);
        }}
        name={value}
      />

      {error || urlError ? <CautionDangerIcon /> : null}
    </div>
  );
};

export default URLInput;

